import { createServerRequest } from '@app/services/__global__/createServerRequest';
import { createServerRequestFile } from '@app/services/__global__/createServerRequestFile';
import { extractHeadersForLogs } from '@app/services/__global__/extractHeadersForLogs';
import { handleCatchError } from '@app/services/__global__/handleCatchError';
import { setAxiosConfig } from '@app/services/__global__/setAxiosConfig';
import { useDeleteSalesFunnelMutation } from '@app/services/rtkQuery/SalesFunnels/api';

import { authenticateByCookie } from './authentication/authenticateByCookie';
import { decryptEmailCookie } from './authentication/decryptEmailCookie';
import { useGetRecordRemindersQuery } from './rtkQuery/notifications';
import { useGetSalesFunnelStagesQuery } from './rtkQuery/SalesFunnelsStages/api';

export {
  authenticateByCookie,
  setAxiosConfig,
  decryptEmailCookie,
  extractHeadersForLogs,
  createServerRequest,
  createServerRequestFile,
  handleCatchError,
  useDeleteSalesFunnelMutation,
  useGetSalesFunnelStagesQuery,
  useGetRecordRemindersQuery,
};
